export const fr = {
    titre: "Erreur",
    titreOnglet: "Erreur | Desjardins",
    "ACC-913": "Les informations de vos comptes ne peuvent pas être affichées pour l’instant. Réessayez plus tard. (ACC-913)",
    "ACC-914": "Les informations de vos comptes ne peuvent pas être affichées pour l’instant. Réessayez plus tard. (ACC-914)",
    "FAD-900": {
        titre: "Financement Accord D",
        texte: "Il n’est plus possible de faire une demande de financement Accord D. Pour choisir un autre produit de financement qui pourrait vous convenir, utilisez notre outil <a href='oel-paas-spa-url/financement/selecteur-produits/'>Trouver un produit de financement</a>.",
        estFormatageHtml: true,
        dsdAlertType: "warning",
    },
    GENERIC: "Une erreur s’est produite. Réessayez plus tard. (ACC-999)",
};
